"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Style = exports.CSS = void 0;
const theme_1 = require("../../components/theme");
exports.CSS = {
    container: 'c-TagList',
    tag: 'c-TagList__item',
    loadmore: 'c-TagList__loadmore',
    cards: {
        container: 'c-TagList__cards',
        head: 'c-TagList__cards-header',
        isEmpty: 'c-TagList__cards--empty',
    },
    collections: {
        container: 'c-TagList__collections',
    },
    empty: {
        message: 'c-TagListEmpty__message',
        reset: 'c-TagListEmpty__reset',
    },
};
exports.Style = {
    [exports.CSS.container]: {
        fontFamily: theme_1.DefaultTheme.font.familyCondensed,
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        height: '100%',
        boxShadow: theme_1.DefaultTheme.shadow.box.dp4,
        minWidth: '20%',
    },
    [exports.CSS.cards.container]: {
        overflowY: 'auto',
        height: '100%',
    },
    [exports.CSS.cards.isEmpty]: {
        display: 'flex',
        'flex-direction': 'column',
        'justify-content': 'center',
        'align-items': 'center',
    },
    [exports.CSS.loadmore]: {
        width: '100%',
        display: 'flex',
        'justify-content': 'center',
    },
    [exports.CSS.cards.head]: {
        display: 'flex',
        justifyContent: 'space-around',
        boxShadow: theme_1.DefaultTheme.shadow.box.dp4,
    },
    [exports.CSS.empty.reset]: {
        cursor: 'pointer',
        color: theme_1.DefaultTheme.color.accent,
    },
};
//# sourceMappingURL=tag.list.style.js.map